/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Button from 'material/ctas/button/button_container';
import Icon from 'material/graphic/icon/icon';
import SaveButton from 'material/ctas/save/save';

// utils
import { isContentValid } from 'utils/embeds/content_validation';
// import {browserAlertOn, browserAlertOff} from "utils/embeds/browser_alert";
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/steps/stepnav/navitem/navitem_styles';



/* ========== ~~~~~~~~~~ STEPNAV : NAV ITEM : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class StepNavItem extends Component {
	constructor(props) {
		super(props);
		this.state = { phase: 'loading' };
		this.timeout = null;
	}

	componentDidMount() {
        this.timeout = setTimeout(() => {
			this.setState({ phase: 'loaded' });
		}, 100);
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
	}

	handleClick = () => {
	    const target = this.stepPageTarget();
	    switch (target) {
			case 'library':
                return this.props.isNewEmbedFlow ? this.props.moveToLibraryWithFetch(this.props.clientUUID) : this.props.moveToPage(target);
            default:
            	this.pageName() === "customize" ? this.moveWithValidation(target) : this.props.moveToPage(target);
        }
	};

	handleSave = () => this.props.handleSaveEmbed();

    moveWithValidation = (target) => {
        if(isContentValid(this.props.selectedContent)) {
            this.props.moveToPage(target)
        } else {
        	// console.log('not valid')
            this.props.invalidateSelectedContent();
            this.props.sendMessage('There are required fields you must fill out before continuing.');
        }
	};

	isNext = () => this.props.type === 'next';

	pageName = () => this.props.stepQueue[this.props.currentStepIndex]['name'];

	getCorrectIndex = () => this.isNext() ? this.props.currentStepIndex + 1 : this.props.currentStepIndex - 1;

	stepPageTarget = () => {
		const idx = this.getCorrectIndex();
		return this.props.stepQueue.length > idx ? idx < 0 ? 'library' : this.props.stepQueue[idx].name  : 'library';
	};

	displayContinueButton = () => this.pageName() === 'revenue' ?
		<SaveButton handleSave={this.handleSave}
					savingData={this.props.isSavingData}
					buttonText={this.props.changeDetected ? null : 'Saved'}
					disabled={!this.props.changeDetected || this.props.isSavingData} />
		:
		<Button type={`custom`} handleClick={this.handleClick} variant={`action`} name={`continue`} text={'Continue'} />;

	displayButton = () => this.isNext() ?
		this.displayContinueButton()
		:
        this.props.isSavingData ? null : <Button type={`custom`} handleClick={this.handleClick} variant={`system`} name={`previous`} text={`Previous Step`} icon={<Icon name={`arrow-left`} />} />;

	render() {
	    return(
	    	<span className={`stepnavitem ${this.props.classes.stepnavitem} ${this.props.type} ${this.state.phase}`}>
	        	{this.displayButton()}
	        </span>
	    );
	}
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(StepNavItem);
